<template>
  <v-select
    multiple
    v-model="activeExt"
    :items="items"
    :label="$t('cdrs.filter.extensions')"
    prepend-icon="mdi-account"
    item-text="name"
    item-value="value">
    <template v-slot:selection="{ index, item }">
      <div v-if="index === 0" style="width: 100%;">
        {{ item.name }}
        {{ activeExt.length > 1 ? `(+${activeExt.length - 1})` : '' }}
      </div>
    </template>
    <template v-slot:prepend-item>
      <v-list-item @click="selectAll">
        <v-list-item-action>
          <v-icon>{{ selectAllIcon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('cdrs.filter.allExtensions') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'exten-select',
  mounted () {
    if (this.activeExt.length === 0) {
      this.setExtensions([this.watchUsers[0].username])
    }
  },
  computed: {
    ...mapGetters({
      watchUsers: 'cdrs/watchUsers',
      extensions: 'cdrs/extensions'
    }),
    items: function () {
      return this.watchUsers.map(ext => ({
        name: `${ext.first_name} ${ext.last_name} <${ext.username}>`,
        value: ext.username
      }))
    },
    activeExt: {
      get: function () {
        return this.extensions
      },
      set: function (val) {
        this.setExtensions(val)
      }
    },
    selectAllIcon: function () {
      if (this.activeExt.length === this.items.length) return 'mdi-checkbox-marked'
      if (this.activeExt.length > 0 && this.activeExt.length < this.items.length) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    ...mapActions({ setExtensions: 'cdrs/setExtensions' }),
    selectAll: function () {
      if (this.activeExt.length === this.watchUsers.length) {
        this.setExtensions([this.watchUsers[0].username])
      } else {
        this.setExtensions(this.watchUsers.map(ext => ext.username))
      }
    }
  },
  watch: {
    activeExt (ext) {
      if (ext.length === 0) {
        this.setExtensions([this.watchUsers[0].username])
      }
      this.$emit('filter')
    }
  }
}
</script>

<style scoped>
</style>
